module.exports = __webpack_public_path__ + "ath_game_web/img/2.4.bbb8625a.png";